export default {
  announcementbar: {
    paths: {
      eventstream: `/users/eventstream`,
    },
    url: `https://zapi.ringana.com/announcement`,
  },
  api: {
    baseurl: `https://zapi.ringana.com`,
    cacheTimeInSeconds: 5,
    errorCodes: {
      notFound: 10001,
      partnerCustomerCartMailAddressMissing: `addCartCustomerEmailEmpty`,
      requestsLimited: 13000,
      requestsLimitedString: `Requests are limited`,
    },
    paths: {
      carts: {
        basepath: `/carts`,
        params: {
          EIGENBEDARF: 1,
          FREMDBEDARF: 2,
          MERCHANDISE: 3,
          PARTNERAPPLICATION: 4,
        },
        paths: {
          count: `/count`,
          coupon: `/coupon`,
          coupons: `/coupons`,
          create: `/create`,
          item: `/item`,
          supplement: `/supplement`,
        },
      },
      challengeRegistration: `/challenge-registration`,
      checkout: {
        basepath: `/checkout`,
        paths: {
          addresses: `/addresses`,
          delivery: `/delivery-types`,
          finish: `/finish`,
          oneclick: `/one-click`,
          payment: `/payment`,
          paymentTerms: `/payment-terms`,
          summary: `/summary`,
        },
      },
      configs: {
        basepath: `/configs`,
        paths: {
          acquisitions: `/acquisitions`,
          bouncer: `/bouncer`,
          countries: `/countries`,
          currencies: `/currencies`,
          languages: `/languages`,
          salutations: `/salutations`,
          splitrun: `/splitrun`,
          strings: `/strings`,
        },
      },
      customers: {
        basepath: `/customers`,
        paths: {
          address: `/address`,
          addresses: `/addresses`,
          autoLogin: `/login/auto`,
          calendar: `/calendar`,
          chatReference: `/chat-reference`,
          confirmEmail: `/confirm-email`,
          confirmNewCustomer: `/confirm`,
          contacts: `/contacts`,
          datasheet: `/datasheet`,
          exists: `/exists`,
          getTaxNumberCaptcha: `/tax-numbers/get-captcha`,
          invoices: `/invoices`,
          invoicingIds: `/invoicing/numbers`,
          invoicings: `/invoicings`,
          login: `/login`,
          loginCheck: `/login/check`,
          logout: `/logout`,
          newCustomers: `/new-customers`,
          newsletterConfirm: `/newsletter`,
          newsletterUnsubscribe: `/newsletter/unsubscribe`,
          newsletterUpdate: `/newsletter`,
          orders: `/orders`,
          partnerUpdateCustomerMailAddress: `/update/mail`,
          recentInvoices: `/invoices/recent`,
          register: `/register`,
          resendTransfer: `/resend-transfer`,
          reset: `/password-request`,
          settings: `/settings`,
          token: `/token`,
          transfer: `/transfer`,
          transferConfirm: `/confirm-transfer`,
          updateNewCustomer: `/update-new-customer`,
          updatePaymentType: `/orders/change-payment-type`,
          vendorData: `/vendor-data`,
        },
      },
      orders: {
        basepath: `/orders`,
        paths: {
          invoice: `/invoice`,
        },
      },
      partnershop: {
        basepath: `/partners`,
        paths: {
          bindFreshbookVouchers: `/bind-freshbook-vouchers`,
          data: `/data`,
          fairScore: `/fair-score`,
          generationsCount: `/generations-count`,
          image: `/image`,
          incentives: `/incentives`,
          invoicingPoints: `/invoicing-points`,
          new: `/new`,
          page: `/page`,
          partnerApplication: `/application`,
          ranking: `/ranking`,
          revenueQuery: `/revenue`,
          search: `/search`,
          subdomains: `/subdomains`,
          upline: `/upline`,
          uplines: `/uplines`,
          vendorRecommendation: `/vendor-recommendation`,
          vote: `/vote`,
        },
      },
      payments: {
        basepath: `/payments`,
        paths: {
          link: `/link`,
          vaults: {
            delete: `/payment-token`,
            list: `/payment-tokens`,
          },
        },
      },
      products: {
        basepath: `/products`,
        paths: {
          favourite: `/favourite`,
          merchandise: `/merchandise`,
          partnerApplications: `/partner-applications`,
          reduced: `/reduced`,
          search: `/search`,
        },
      },
      statistics: {
        basepath: `/statistics`,
        paths: {
          dashboard: `/dashboard`,
          invoices: `/invoices`,
          members: {
            basepath: `/members`,
            paths: {
              customer: `/customer`,
              team: {
                basepath: `/team`,
                paths: {
                  customer: `/customer`,
                },
              },
            },
          },
          partnerDashboard: `/partner-dashboard`,
          revenue: {
            basepath: `/revenue`,
            paths: {
              team: `/team`,
            },
          },
        },
      },
      teams: {
        basepath: `/teams`,
        paths: {
          customers: `/customers`,
          export: `/export`,
          generations: `/generations`,
          inactivePartners: `/inactive`,
          newTargetLevels: `/target-levels/new`,
          newVendorVolume: `/partners/new-volumes`,
          partners: `/partners`,
          rankings: `/rankings`,
          revenueQuery: `/revenue`,
          targetLevels: {
            basepath: `/target-levels`,
            paths: {
              data: `/data`,
            },
          },
          teamCount: `/count`,
          teamGrowth: `/growth`,
        },
      },
    },
    searchbox: {
      offset: 5,
      resultLimit: 5,
    },
  },
  banks: [
    {
      bic: `BIC: BFKKAT2K`,
      iban: `IBAN: AT68 1700 0001 8501 0082`,
      name: `BKS Bank`,
      translationKey: `forAustria`,
    },
    {
      bic: `BIC: OBKLDEMX`,
      iban: `IBAN: DE21 7012 0700 1001 1996 50`,
      name: `Oberbank Bayern AG München`,
      translationKey: `forGermany`,
    },
    {
      bc: `BC-Nr.: 8525`,
      bic: `BIC/SWIFT: BTVACH22XXX`,
      esr: `ESR-Nr.: 01-062471-9`,
      iban: `IBAN: CH54 0852 5000 SA31 507A A`,
      name: `Bank für Tirol und Vorarlberg Aktiengesellschaft, Innsbruck, Zweigniederlassung Staad`,
      translationKey: `forSwitzerland`,
    },
    {
      bic: `BIC: CRBZIT2B050`,
      iban: `IBAN: IT29 Q060 4558 2200 0000 5004 370`,
      name: `Cassa di Risparmio`,
      translationKey: `forItaly`,
    },
    {
      accountNumber: `Account no.: 27061200`,
      bic: `BIC: GENOGB2L`,
      iban: `IBAN: GB80 GENO 4050 8227 0612 00`,
      name: `DZ BANK AG`,
      sortCode: `Sort Code: 405082`,
      translationKey: `forGreatBritain`,
    },
    {
      accountNumber: `Císlo úctu: 2351105962`,
      bic: `BIC: OBKLCZ2X`,
      iban: `IBAN: CZ21 8040 0000 0023 5110 5962`,
      name: `Oberbank AG pobočka Česká republika`,
      sortCode: `Kód banky: 8040`,
      translationKey: `forCzechRepublic`,
    },
    {
      bic: `BIC: BREXPLPWXXX`,
      iban: `IBAN: PL65 1140 1010 0000 3370 1700 1001`,
      name: `mBank`,
      translationKey: `forPoland`,
    },
    {
      bban: `BBAN: 12094507 - 01734586 - 00100005`,
      iban: `IBAN: HU58 1209 4507 0173 4586 0010 0005`,
      name: `Raiffeisen Bank Zrt`,
      translationKey: `forHungary`,
    },
    {
      bic: `BIC: BFKKAT2K`,
      iban: `IBAN: AT68 1700 0001 8501 0082`,
      name: `BKS Bank`,
      translationKey: `forOther`,
    },
  ],
  bouncer: {
    api: {
      baseurl: `https://zapi.ringana.com/hodor`,
      paths: {
        finish: `/finish`,
        newUser: `/newuser`,
        status: `/status`,
      },
    },
    config: {
      closeToOpenThreshold: 50,
      endTimeOffsetInMinutes: 10,
    },
    ws: {
      baseurl: `wss://zapi.ringana.com/hodor`,
    },
  },
  breakpoints: {
    gridToListView: 780,
    maxMobile: 720,
    smallDesktop: 1000,
  },
  cartTypes: {
    EIGENBEDARF: 1,
    FREMDBEDARF: 2,
    MERCHANDISE: 3,
    PARTNERAPPLICATION: 4,
  },
  challengeRegistration: {
    images: {
      albertoNodale: `/wp-content/themes/JointsWP/assets/images/albertonodale.png`,
      carinaBerry: `/wp-content/themes/JointsWP/assets/images/carina_berry.png`,
      deatGif: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2019/09/Ringana_deat_web_03_gif.gif`,
      deatPackage: `/wp-content/themes/JointsWP/assets/images/d-eat_package.png`,
      ellipse: `/wp-content/themes/JointsWP/assets/images/ellipse.svg`,
    },
    links: {
      albertoNodale: `https://www.instagram.com/albertonodale/`,
      carinaBerry: `https://www.instagram.com/carina_berry/`,
      deatProductLink: `https://www.ringana.com/produkt/complete-d-eat/`,
      ringanaInstagram: `https://www.instagram.com/ringana/`,
    },
  },
  companyInfo: {
    address: `RINGANA Campus A 1`,
    addressTown: `8295 St. Johann in der Haide`,
    ringana: `RINGANA GmbH`,
    web: `Austria - www.ringana.com`,
  },
  contactBackoffice: {
    mail: `backoffice@ringana.com`,
    phone: `+43333261550`,
    phoneLabel: `+43 (0) 3332/61550`,
  },
  cookie: {
    domain: window.location.host.search(/localhost/i)
    === 0 ? `localhost` : window.location.host.replace(/^(.*?)\.(?!(\..*\.com))/, ``),
    maxAgeInSeconds: 60 * 60 * 24 * 365,
  },
  coupons: {
    minLength: 8, // same as validation on zAPI endpoint POST /cart/coupon
  },
  currencies: {
    EUR: `EUR`,
  },
  fapi: {
    baseurl: `https://fapi.ringana.com/`,
  },
  googleMap: {
    apiKey: `&key=AIzaSyA6B67oc6yiFLU20jw2yuSB5sMCVVZrJGU`,
    embedUrl: `https://www.google.com/maps/embed/v1/place?q=`,
  },
  header: {
    links: {
      cart: {
        cs: `/warenkorb/?lang=cs`,
        de: `/warenkorb/`,
        en: `/shopping-cart/?lang=en`,
        es: `/cesta-de-compras/?lang=es`,
        fr: `/panier/?lang=fr`,
        hu: `/kosar/?lang=hu`,
        it: `/carrello/?lang=it`,
        nl: `/winkelmandje/?lang=nl`,
        pl: `/koszyk/?lang=pl`,
        pt: `/warenkorb/?lang=pt`,
        sk: `/warenkorb/?lang=sk`,
      },
      login: {
        cs: `/anmeldung/?lang=cs`,
        de: `/anmeldung/`,
        en: `/login/?lang=en`,
        es: `/iniciar-sesion/?lang=es`,
        fr: `/connexion/?lang=fr`,
        hu: `/anmeldung/?lang=hu`,
        it: `/login/?lang=it`,
        nl: `/inloggen/?lang=nl`,
        pl: `/zaloguj-sie/?lang=pl`,
        pt: `/anmeldung/?lang=pt`,
        sk: `/anmeldung/?lang=sk`,
      },
    },
  },
  images: {
    cartHeaderWrapper: `https://i.ringana.com/2021/10/pJMDvBID-Warenkorb_Banner_2021.jpg`,
    flowerBlack: `/wp-content/themes/JointsWP/assets/images/ringana-blume-black.svg`,
    paths: {
      achievers: {
        defaultVideoBanner: `https://i.ringana.com/wp-content/uploads/2018/03/04092730/poster-video-ringana-people.jpg`,
      },
      imgix: `https://i.ringana.com/partnerimages/`,
      jobs: {
        companyDoctorPrimary: `https://i.ringana.com/2020/01/CF000514_preview.jpg`,
        companyDoctorSecondary: `https://i.ringana.com/2020/01/ringana_katharina_15292.jpg`,
        developmentPotentialPrimary: `https://i.ringana.com/2020/01/rz_CF000201.jpg`,
        developmentPotentialSecondary: `https://i.ringana.com/2020/01/ringana29665_2.jpg`,
        environmentPrimary: `https://i.ringana.com/2020/01/ringana_katharina20304-quer.jpg`,
        environmentSecondary: `https://i.ringana.com/2020/01/DSC3354_2_neu.jpg`,
        foodPrimary: `https://i.ringana.com/2020/01/B0014891.jpg`,
        foodSecondary: `https://i.ringana.com/2020/01/ringana30387_2.jpg`,
        internationalBottom: `https://i.ringana.com/2020/01/RINGANA-Imagemodel_23.jpg`,
        internationalTop: `https://i.ringana.com/2020/01/RINGANAchi_-_QM.jpg`,
        parking: `https://i.ringana.com/2020/01/ringana30068.jpg`,
      },
    },
  },
  jobs: {
    iframe: {
      deConfigKey: `k2avuysm`,
    },
  },
  links: {
    frenchPassportUploadLink: `https://ringana.fiskanet.fr/Account/URSSAFDraftRequest`,
    microsoftEdgeDownloadUrl: `https://www.microsoft.com/en-us/edge`,
  },
  locize: {
    announcementBar: {
      PROJECTID: `897f9dd4-8eac-4210-8deb-affd64313946`,
      namespaces: {
        UFE: `announcement-bar-ufe`,
      },
    },
    frontPage: {
      PROJECTID: `e995e795-6804-45a7-9676-2b5e50a27545`,
      REFERENCELANGUAGE: `de`,
      namespaces: {
        FRONTPAGE: `frontpage-ufe`,
        PARTNERSHOP: `partnershop`,
      },
    },
    webshopWordpress: {
      PROJECTID: `f9fc251c-66ad-4ed7-89a5-5de84ec3a52b`,
      REFERENCELANGUAGE: `de`,
      namespaces: {
        ACTIVATEACCOUNTREF: `activate-account-ref`,
        CALENDAR: `calendar`,
        CART: `cart`,
        CHECKOUT: `checkout`,
        CONTACT: `contact`,
        CUSTOMERACCOUNT: `customer-account`,
        CUSTOMERTRANSFERREF: `customer-transfer-ref`,
        CUSTOMER_STATISTICS: `customer-statistics`,
        DATASHEET: `datasheet`,
        DATEPICKER: `datepicker`,
        DOWNLOADS: `downloads`,
        ERRORREF: `error-ref`,
        ERRORS: `errors`,
        FOOTER: `footer`,
        HEADER: `header`,
        INCENTIVES: `incentives`,
        INTERESTINGFORYOU: `interesting-for-you`,
        JOBS: `jobs`,
        LIMITING: `limiting`,
        MAGAZINE: `magazine`,
        MEDIA: `in-the-media`,
        MENU: `menu`,
        MISC: `misc`,
        MYORDERS: `my-orders`,
        MYORDERSREF: `my-orders-ref`,
        MYPROFILE: `my-profile`,
        MYTEAM: `my-team`,
        NEWSLETTERREF: `newsletter-ref`,
        NEWSLETTERUNSUBSCRIBEREF: `newsletter-unscubscribe-ref`,
        PARTNERAPPLICATION: `partner-application`,
        PARTNERDASHBOARD: `partner-dashboard`,
        PARTNERSHOP: `partnershop`,
        PARTNER_PROFILE: `partner-profile`,
        POINTS_INVOICING: `points-invoicing`,
        POPUPS: `popups`,
        PRESS: `press`,
        PRODUCTSOVERVIEW: `products-overview`,
        REGISTRATION: `registration`,
        RESETPASSWORD: `reset-password`,
        REVENUEBAROMETER: `revenue-barometer`,
        REVENUESTATISTICS: `revenue-statistics`,
        SALESSTATISTICS: `sales-statistics`,
        SEARCH: `search`,
        SHIPPING: `shipping`,
        TEAMSTATISTICS: `team-statistics`,
        VOUCHERS: `vouchers`,
      },
    },
  },
  partnerDashboard: {
    freshbook: {
      maxVoucherInputs: 10,
      productUrls: {
        cs: `/partner-produkt/freshbook-voucher-cs/`,
        de: `/partner-produkt/freshbook-voucher/`,
        en: `/partner-produkt/freshbook-voucher-en/`,
        es: `/partner-produkt/freshbook-voucher-es/`,
        fr: `/partner-produkt/freshbook-voucher-fr/`,
        hu: `/partner-produkt/freshbook-voucher-hu/`,
        it: `/partner-produkt/freshbook-voucher-it/`,
        nl: `/partner-produkt/freshbook-voucher-nl/`,
        pl: `/partner-produkt/freshbook-voucher-pl/`,
        pt: `/partner-produkt/freshbook-voucher-pt/`,
        sk: `/partner-produkt/freshbook-voucher-sk/`,
      },
    },
  },
  partnershop: {
    images: {
      flowerBlack: `/wp-content/themes/JointsWP/assets/images/ringana-blume-black.svg`,
      letter: `/wp-content/themes/JointsWP/assets/images/letter.svg`,
      phoneBlack: `/wp-content/themes/JointsWP/assets/images/phone-black.svg`,
      pinBlack: `/wp-content/themes/JointsWP/assets/images/pin-black.svg`,
    },
  },
  phoneTypes: {
    MOBILE: 2,
    TELEPHONE: 1,
  },
  press: {
    imageCategories: [
      { locizeKey: `owners`, value: `eigentuemer` },
      { locizeKey: `modelWithProduct`, value: `modelmitprodukt` },
      { locizeKey: `modelWithoutProduct`, value: `modelohneprodukt` },
      { locizeKey: `sustainability`, value: `nachhaltigkeit` },
      { locizeKey: `production`, value: `produktion` },
      { locizeKey: `productStyleImages`, value: `produktstilbilder` },
      { locizeKey: `sport`, value: `sport` },
    ],
    /* eslint-disable sort-keys */
    productCategories: {
      1: `Face`,
      2: `Body`,
      3: `Hair`,
      4: `Samples`,
      5: `Caps`,
      6: `Packs`,
      7: `Drinks`,
      8: `Sport`,
      9: `Angebote`,
      10: `Complete`,
    },
    /* eslint-enable sort-keys */
  },
  products: {
    availableDiscounts: [10, 15, 20, 30, 40, 50, 60, 70, 80, 90],
    images: {
      10: `/wp-content/themes/JointsWP/assets/images/-10.png`,
      15: `/wp-content/themes/JointsWP/assets/images/-15.png`,
      20: `/wp-content/themes/JointsWP/assets/images/-20.png`,
      30: `/wp-content/themes/JointsWP/assets/images/-30.png`,
      40: `/wp-content/themes/JointsWP/assets/images/-40.png`,
      50: `/wp-content/themes/JointsWP/assets/images/-50.png`,
      60: `/wp-content/themes/JointsWP/assets/images/-60.png`,
      70: `/wp-content/themes/JointsWP/assets/images/-70.png`,
      80: `/wp-content/themes/JointsWP/assets/images/-80.png`,
      90: `/wp-content/themes/JointsWP/assets/images/-90.png`,
      soldOut: `/wp-content/themes/JointsWP/assets/images/sold-out.png`,
    },
    overviewImageWidthInPixel: 300,
    partnerShopSlugs: [`equipment`, `prints`, `partner-shop`, `products`],
    shopCategories: {
      complete: [`complete`],
      fresh: [`body`, `face`, `fresh`, `hair`],
      offers: [`angebote`, `offres`, `offerte`, `ofertas`, `aanbiedingen`, `oferty`, `ajanlatok`],
      sports: [`sports`],
      supplements: [`caps`, `drinks`, `packs`, `supplements`],
    },
    specialMerchandiseMatchCodes: [`VKP`, `VKR`, `IBS`, `IBW`],
    specialShopCategoriesURLSlugs: {
      allProducts: [`alle-produkte`, `all-products`, `tous-les-produits`, `tutti-i-prodotti`, `todos-los-productos`, `alle-producten`, `wszystkie-produkty`, `az-oesszes-termek`],
      offers: [`angebote`, `offers`, `offres`, `offerte`, `ofertas`, `aanbiedingen`, `oferty`, `ajanlatok`],
      sport: [`sport`],
    },
    unitContentsIds: [804, 812, 827, 996], // capsules, g, ml, pcs
  },
  recaptcha: {
    siteKey: `6LcI3bkZAAAAAJ5aBiiomhotOagAxdbdlNiJQdE3`,
  },
  ringana: {
    baseurl: `https://ringana.com`,
    events: `https://www.ringana.events/`,
    paths: {
      academy: `/academy`,
      cart: `/warenkorb`,
      incentives: `/incentives`,
      myData: `/meine-daten`,
      productInformation: `/product-information`,
      summits: `/summits`,
    },
  },
  ringanaBlog: {
    topicOptions: [
      { code: 11111, label: `Ringana` },
      { code: 99, label: `Sport` },
      { code: 105, label: `Lifestyle` },
      { code: 110, label: `Know-How` },
      { code: 116, label: `Corporate` },
      { code: 124, label: `We Love` },
      { code: 432, label: `Sustainability` },
      { code: 438, label: `Recipe` },
      { code: 488, label: `Business` },
    ],
  },
  sessionStack: {
    projectId: `266119875e1b45fe80945d66ae784933`,
  },
  socialMediaUrls: {
    facebook: `https://www.facebook.com/RINGANA`,
    instagram: `https://www.instagram.com/ringana/`,
    pinterest: `https://www.pinterest.de/ringana/`,
    youtube: `https://www.youtube.com/user/RINGANA2012`,
  },
  testgroup: [
    2484303,
    2493633,
    1428809,
    414245,
    1722741,
    618115,
    1208634,
    1268893,
    2212277,
    2186949,
    186856,
    944751,
    100001,
    2205006,
  ],
  unicodes: [
    { code: `&#8230;`, replacement: `...` },
    { code: `&#8217;`, replacement: `'` },
    { code: `&#8211;`, replacement: `–` },
    { code: `&amp;`, replacement: `&` },
    { code: `&nbsp;`, replacement: ` ` },
  ],
  videos: {
    paths: {
      achievers: {
        cs: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FMOO_RinganaBusinessFilm_CZECH_WEB.mp4`,
        de: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FRINGANA-Businessfilm-2019-DE_WEB.mp4`,
        default: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FRINGANA-Businessfilm-2019-DE_WEB.mp4`,
        en: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FRINGANA-Businessfilm-2019_WEB.mp4`,
        es: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FRINGANA-Businessfilm-2019-ES_WEB.mp4`,
        fr: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FRINGANA-Businessfilm-2019-FR_WEB.mp4`,
        it: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FRINGANA-Businessfilm-2019-IT_WEB.mp4`,
        pl: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FRINGANA-Businessfilm-2019-PL_WEB.mp4`,
        pt: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FMOO_RinganaBusinessFilm_PT_WEB.mp4`,
        sk: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2020%2F03%2FMOO_RinganaBusinessFilm_SK_WEB.mp4`,
      },
    },
  },
  vouchers: {
    matchcode: `FGS`,
  },
  wpUrls: {
    checkout: `/checkout`,
    dataSheet: `/kundendatenblatt`,
    exclusiveShopping: `/exclusive-shopping`,
    invoiceList: `/rechnungsliste`,
    invoicingPoints: `/punkteabrechnung`,
    login: `/anmeldung`,
    myAccount: `/mein-kundenkonto`,
    myData: `/meine-daten`,
    myDataDutch: `/mijn-gegevens`,
    myDataEnglish: `/my-information`,
    myDataItalian: `/i-miei-dati`,
    myDataPolish: `/moje-dane`,
    myDataSpanish: `/mis-datos`,
    myTeam: `/mein-team`,
    newCustomer: `/neuer-kunde`,
    pointsInvoicing: `/punkteabrechnung`,
    restapi: {
      baseurl: `/`,
      endpoints: {
        eventProductsOverviewBySlug: `/eventProductsOverviewBySlug`,
        news: `/newsNewRoute`,
        press: {
          images: `/press/images`,
          productinfos: `/press/productimages`,
          releases: `/press/releases`,
        },
        productCategories: `/productCategories`,
        productsByCategory: `/productsByCategory`,
        urls: `/urls`,
        video: `/video/posts`,
      },
      path: `/wp-json/ringana/v1`,
    },
    revenueQuery: `/statistiken-umsatzabfrage`,
    revenueQueryTeam: `/statistiken-umsatzabfrage?type=team`,
    teamQuery: `/statistiken-teamabfrage`,
    teamQueryMyRankings: `/statistiken-teamabfrage/#myRankings`,
    teamQueryNewlyReachedTargetLevels: `/statistiken-teamabfrage/#teamNewlyReachedTargetLevels`,
  },
};
